import { useMutation } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { useInvalidateProjectTagsQuery } from './useInvalidateTagsQuery';

export const useReorderTagsMutation = (projectId: number) => {
  const invalidateTagsQuery = useInvalidateProjectTagsQuery(projectId);

  const apiClient = useChatApiClient();

  return useMutation({
    mutationKey: ['patch:projects/tags/reorder', projectId],
    mutationFn: (ordinalMap: Record<number, number>) => {
      const ordinals = Object.entries(ordinalMap).map(([id, ordinal]) => ({
        id: Number(id),
        ordinal,
      }));
      return apiClient.projects.reorderProjectTags({ projectId, ordinals });
    },
    onSuccess: (_, ordinalMap) => {
      invalidateTagsQuery();
    },
  });
};
